import React from 'react';
import { NavigationSidebar } from '../components/NavigationSidebar';
import { MobileMenu } from '../components/MobileMenu';
import { motion } from 'framer-motion';
export function JournalsPage() {
  return <div className="min-h-screen w-full relative overflow-x-hidden" data-id="element-229">
      {/* Fonts import */}
      <style data-id="element-230">{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=Space+Mono:ital,wght@0,400;0,700;1,400&family=Young+Serif&display=swap');
        
        .font-mono { font-family: 'Space Mono', monospace; }
        .font-serif { font-family: 'Young Serif', serif; }
        .font-editorial { font-family: 'Playfair Display', serif; }
        
        .text-outline {
          -webkit-text-stroke: 1px #000;
          color: transparent;
        }
      `}</style>

      {/* Background Image */}
      <div className="fixed inset-0 z-0" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/xAadGRTQavPrAfmLQeMtNB/0_0-5.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-231" />

      <div className="relative z-10 flex min-h-screen" data-id="element-232">
        {/* Mobile Menu - Only visible on mobile */}
        <MobileMenu data-id="element-233" />

        {/* Desktop Navigation - Hidden on mobile */}
        <div className="hidden md:block" data-id="element-234">
          <NavigationSidebar data-id="element-235" />
        </div>

        <main className="flex-1 flex items-center justify-center p-4 py-12" data-id="element-236">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="relative w-full max-w-4xl mx-auto p-2 md:p-4" data-id="element-237">
            {/* Main Container with rounded corners and thin black border */}
            <div className="relative bg-white p-8 md:p-16 min-h-[80vh] flex flex-col rounded-3xl shadow-2xl border border-black" data-id="element-238">
              {/* Content */}
              <div className="w-full z-10 max-w-3xl mx-auto" data-id="element-239">
                {/* Header Label */}
                <div className="mb-8" data-id="element-240">
                  <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-outline uppercase" style={{
                  fontFamily: 'system-ui, sans-serif'
                }} data-id="element-241">
                    stories / essays
                  </h2>
                </div>

                {/* Article Header */}
                <div className="mb-12" data-id="element-242">
                  <h1 className="text-3xl md:text-5xl font-bold text-black mb-6 tracking-tight text-left leading-tight" style={{
                  fontFamily: "'Fette Fraktur', cursive"
                }} data-id="element-243">
                    Redesigning the Citizenship Stack
                  </h1>

                  <div className="flex flex-col space-y-1 text-sm font-mono text-gray-800" data-id="element-244">
                    <p data-id="element-245">by Annissa ★</p>
                    <p className="text-gray-600" data-id="element-246">published January 22, 2026</p>
                  </div>
                </div>

                {/* Article Body */}
                <article className="prose prose-sm max-w-none font-editorial text-black" data-id="element-247">
                  <h3 className="text-xl font-bold text-black mb-4 mt-8" style={{
                  fontFamily: "'Fette Fraktur', cursive"
                }} data-id="element-248">
                    Introduction
                  </h3>

                  <p className="mb-6 leading-relaxed text-sm" data-id="element-249">
                    Lorem ipsum dolor sit amet consectetur adipiscing elit sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur.
                  </p>

                  <p className="mb-6 leading-relaxed text-sm" data-id="element-250">
                    Sed ut perspiciatis unde omnis iste natus error sit
                    voluptatem accusantium doloremque laudantium totam rem
                    aperiam eaque ipsa quae ab illo inventore veritatis et quasi
                    architecto beatae vitae dicta sunt explicabo. Nemo enim
                    ipsam voluptatem quia voluptas sit aspernatur aut odit aut
                    fugit sed quia consequuntur magni dolores eos qui ratione
                    voluptatem sequi nesciunt.
                  </p>

                  <p className="mb-6 leading-relaxed text-sm" data-id="element-251">
                    Neque porro quisquam est qui dolorem ipsum quia dolor sit
                    amet consectetur adipisci velit sed quia non numquam eius
                    modi tempora incidunt ut labore et dolore magnam aliquam
                    quaerat voluptatem. Ut enim ad minima veniam quis nostrum
                    exercitationem ullam corporis suscipit laboriosam nisi ut
                    aliquid ex ea commodi consequatur.
                  </p>

                  <p className="mb-8 leading-relaxed text-sm" data-id="element-252">
                    Quis autem vel eum iure reprehenderit qui in ea voluptate
                    velit esse quam nihil molestiae consequatur vel illum qui
                    dolorem eum fugiat quo voluptas nulla pariatur.
                  </p>

                  <h3 className="text-xl font-bold text-black mb-4 mt-12" style={{
                  fontFamily: "'Fette Fraktur', cursive"
                }} data-id="element-253">
                    Lorem Ipsum Dolor
                  </h3>

                  <p className="mb-6 leading-relaxed text-sm" data-id="element-254">
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis praesentium voluptatum deleniti atque
                    corrupti quos dolores et quas molestias excepturi sint
                    occaecati cupiditate non provident similique sunt in culpa
                    qui officia deserunt mollitia animi id est <em data-id="element-255">laborum</em>{' '}
                    et dolorum fuga et harum quidem rerum facilis est et
                    expedita distinctio.
                  </p>

                  <p className="mb-6 leading-relaxed text-sm" data-id="element-256">
                    Nam libero tempore cum soluta nobis est eligendi optio
                    cumque nihil impedit quo minus id quod maxime placeat facere
                    possimus omnis voluptas assumenda est omnis dolor
                    repellendus:
                  </p>

                  <ul className="list-disc pl-6 space-y-3 mb-8 marker:text-black text-sm" data-id="element-257">
                    <li className="pl-2" data-id="element-258">
                      <strong className="font-bold" data-id="element-259">Temporibus autem:</strong>{' '}
                      quibusdam et aut officiis debitis aut rerum
                    </li>
                    <li className="pl-2" data-id="element-260">
                      <strong className="font-bold" data-id="element-261">
                        Necessitatibus saepe:
                      </strong>{' '}
                      eveniet ut et voluptates repudiandae sint et molestiae
                    </li>
                    <li className="pl-2" data-id="element-262">
                      <strong className="font-bold" data-id="element-263">Non recusandae:</strong>{' '}
                      itaque earum rerum hic tenetur a sapiente delectus
                    </li>
                  </ul>

                  <h3 className="text-xl font-bold text-black mb-4 mt-12" style={{
                  fontFamily: "'Fette Fraktur', cursive"
                }} data-id="element-264">
                    Consectetur Adipiscing
                  </h3>

                  <p className="mb-6 leading-relaxed text-sm" data-id="element-265">
                    Et harum quidem rerum facilis est et expedita distinctio nam
                    libero tempore cum soluta nobis est eligendi optio cumque
                    nihil impedit. Quo minus id quod maxime placeat facere
                    possimus omnis voluptas assumenda est omnis dolor
                    repellendus temporibus autem quibusdam et aut officiis
                    debitis aut rerum necessitatibus saepe eveniet.
                  </p>
                </article>

                {/* Footer/Next Article */}
                <div className="mt-20 pt-10 border-t border-black/10" data-id="element-266">
                  <p className="font-mono text-xs text-gray-500 uppercase tracking-wider mb-4" data-id="element-267">
                    Next Story
                  </p>
                  <h4 className="text-2xl font-bold cursor-pointer hover:text-gray-600 transition-colors" style={{
                  fontFamily: "'Fette Fraktur', cursive"
                }} data-id="element-268">
                    The Architecture of Belonging
                  </h4>
                </div>
              </div>
            </div>
          </motion.div>
        </main>
      </div>
    </div>;
}